/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import {Grid, CircularProgress, Typography, Button, Tooltip, TextField} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import {
    buildSomeClassifier,
    buildSomeModels,
    buildSomeFingrams,
    buildSomeIEE, uploadDataset
} from "../components/global/API";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import AlgorithmCard from "../components/algorithm/AlgorithmCard";
import {CheckCircle, CloudUpload} from "@material-ui/icons";
import FormConfigureJ48 from "../components/builder/FormConfigureJ48";
import FormConfigureFURIA from "../components/builder/FormConfigureFURIA";
import FormConfigurationHTFuzzy from "../components/builder/FormConfigurationHTFuzzy";
import FormConfigurationREP from "../components/builder/FormConfigurationREP";
import FormConfigureRandom from "../components/builder/FormConfigureRandom";
import FormConfigureRandomForest from "../components/builder/FormConfigureRandomForest";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";

const styles = theme => ({
    root: {
        marginTop: 40,
        justifyContent: "center",
        justifyItems: "center",
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
    },
    container: {
        marginTop: 70,
        justifyContent: "center",
        justifyItems: "center",
        display: "grid",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        textAlign:"center",
    },
    button: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    progress: {
        margin: "auto",
        marginTop: 40,
        marginBottom: 30
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    },
    switchClassDisabled:{
        color:"primary",
    },
    footer:{
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        display:"inline-table",
        justifyContent:"space-evenly",
        position:"fixed",
        bottom:0,
        height:100,
        left:0,
        width:"100%",
        backgroundColor:"white",
    },
    centerFotter:{
        display:"flex",
        justifyContent:"space-evenly",
    },
    leftLogos: {
        height: 36,
        marginTop: 20,
        marginBottom: 20
    },
    rightLogos: {
        height: 60,
        marginTop: 20,
        marginBottom: 20
    },
});

class Algorithms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.classifierExists ? this.props.dataset:"example",
            nameError:false,
            error: false,
            loading: false,
            file:undefined,
            j48:true,
            randomTree:true,
            repTree:true,
            furia:true,
            htFuzzy:true,
            randomForest:true,
            j48Configuration:false,
            randomTreeConfiguration:false,
            repTreeConfiguration:false,
            furiaConfiguration:false,
            htFuzzyConfiguration:false,
            randomForestConfiguration:false,
            checkedA:true,
            checkedB:false,
            algorithms: ["J48","RandomTree","REPTree","FuzzyHoeffdingDecisionTree","FURIA","RandomForest"],
            FURIAparams: {
                tnorm: 0,
                batchSize: 100,
                checkErrorRate: true,
                doNotCheckCapabilities: false,
                folds: 3,
                minNo: 2,
                numDecimalPlaces: 2,
                optimizations: 2,
                seed: 1,
                uncovAction: 0
            },
            HTparams: {
                fuzzyCardinality: true,
                fuzzySets: 3,
                propertyLabels:"L1,L2,L3",
                centroids: "0.5",
                gracePeriod: 25.0,
                hoeffdingTieThreshold: 2.5,
                leafPredictionStrategy:0,
                minimumFractionOfWeightInfoGain: 0.01,
                naiveBayesPredictionThreshold: 0.0,
                numDecimalPlaces: 2,
                printLeafModels: false,
                admitRepetitions:false,
                splitConfidence: 1.0e-7,
                splitCriterion:1
            },
            J48params: {
                binarySplits: false,
                collapseTree: true,
                doNotMakeSplit: false,
                confidenceFactor: 0.25,
                minNumObj: 2,
                numFolds: 3,
                reduceError: false,
                seed: 1,
                subtreeRaising: true,
                unpruned: false,
                useLaplace: false,
                useMDL: true
            },
            Randomparams: {
                valueK: 0,
                minNumObj: 1,
                minVarianceProp: 0.001,
                seed: 1,
                maxDepth: 0,
                numFolds: 0,
                allowUnclassified: false,
                breakTies: false,
                numDecimalPlaces: 2
            },
            REPparams: {
                noCheckCapabilities: false,
                initialCount: 0,
                maxDepth: -1,
                minNumObj: 2,
                minVarianceProp: 0.001,
                noPruning: false,
                numDecimal: 2,
                numFolds: 3,
                seed: 1,
                spreadInitialCount: false
            },
            RandomForestParams: {
                bagSizePercent: 100,
                batchSize: 100,
                breakTiesRandomly: false,
                calcOutOfBag: false,
                completeAttributeImportance: false,
                debug:false,
                doNotCheckCapabilities: false,
                maxDepth:0,
                numDecimalPlaces: 2,
                numExecutionSlots: 1,
                numFeatures: 0,
                numIterations:100,
                outputOutOfBagComplexityStatistics:false,
                printClassifiers:false,
                seed:1,
                storeOutOfBagPredictions:false,
            },
            clickButton:false,
        };
        this.changeFile = this.changeFile.bind(this);
        this.configuration = this.configuration.bind(this);
        this.handleAlgorithmClick = this.handleAlgorithmClick.bind(this);
        this.saveConfigurationJ48 = this.saveConfigurationJ48.bind(this);
        this.cancelConfigurationJ48 = this.cancelConfigurationJ48.bind(this);
        this.saveConfigurationRepTree = this.saveConfigurationRepTree.bind(this);
        this.cancelConfigurationRepTree = this.cancelConfigurationRepTree.bind(this);
        this.saveConfigurationRandomTree = this.saveConfigurationRandomTree.bind(this);
        this.cancelConfigurationRandomTree = this.cancelConfigurationRandomTree.bind(this);
        this.saveConfigurationFuria = this.saveConfigurationFuria.bind(this);
        this.cancelConfigurationFuria = this.cancelConfigurationFuria.bind(this);
        this.saveConfigurationHTFuzzy = this.saveConfigurationHTFuzzy.bind(this);
        this.cancelConfigurationHTFuzzy = this.cancelConfigurationHTFuzzy.bind(this);
        this.saveConfigurationRandomForest = this.saveConfigurationRandomForest.bind(this);
        this.cancelConfigurationRandomForest = this.cancelConfigurationRandomForest.bind(this);
        this.buildClassifier = this.buildClassifier.bind(this);
        this.selectOneAlgorithm = this.selectOneAlgorithm.bind(this);
        this.changeAlgorithm = this.changeAlgorithm.bind(this);
        this.cancelBuild = this.cancelBuild.bind(this);
        this.buildClassifierPromise = this.buildClassifierPromise.bind(this);
        this.handleChangeSwitchA = this.handleChangeSwitchA.bind(this);
        this.handleChangeSwitchB = this.handleChangeSwitchB.bind(this);
    }




    async componentDidMount() {
    }
    saveConfigurationJ48 (J48params){
        this.setState({
            J48params:J48params,
            j48Configuration:false,
        })
    }
    cancelConfigurationJ48 (J48params){
        this.setState({
            j48Configuration:false,
        })
    }
    saveConfigurationRepTree (J48params){
        this.setState({
            REPparams:J48params,
            repTreeConfiguration:false,
        })
    }
    cancelConfigurationRepTree (J48params){
        this.setState({
            repTreeConfiguration:false,
        })
    }
    saveConfigurationRandomTree (J48params){
        this.setState({
            Randomparams:J48params,
            randomTreeConfiguration:false,
        })
    }
    cancelConfigurationRandomTree (J48params){
        this.setState({
            randomTreeConfiguration:false,
        })
    }
    saveConfigurationFuria (J48params){
        this.setState({
            FURIAparams:J48params,
            furiaConfiguration:false,
        })
    }
    cancelConfigurationFuria (J48params){
        this.setState({
            furiaConfiguration:false,
        })
    }
    saveConfigurationHTFuzzy (HTFuzzyParams){
        this.setState({
            HTparams:HTFuzzyParams,
            htFuzzyConfiguration:false,
        })
    }

    cancelConfigurationHTFuzzy (){
        this.setState({
            htFuzzyConfiguration:false,
        })
    }
    saveConfigurationRandomForest (randomForestParams){
        this.setState({
            RandomForestParams:randomForestParams,
            randomForestConfiguration:false,
        })
    }

    cancelConfigurationRandomForest (){
        this.setState({
            randomForestConfiguration:false,
        })
    }

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({
            error: false
        });
    };
    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }
    configuration(algoritmo){
        if(algoritmo === "J48"){
            this.setState({
                j48Configuration:true
            })
        }else if(algoritmo === "RandomTree"){
            this.setState({
                randomTreeConfiguration:true
            })
        }else if(algoritmo === "REPTree"){
            this.setState({
                repTreeConfiguration:true
            })
        }else if(algoritmo === "FURIA"){
            this.setState({
                furiaConfiguration:true
            })
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            this.setState({
                htFuzzyConfiguration:true
            })
        }else if(algoritmo === "RandomForest"){
            this.setState({
                randomForestConfiguration:true
            })
        }
    }

     cancelBuild(){
        if(this.props.classifierExists) {
            this.props.changeAlgorithm(this.props.lastAlgorithm,this.state.name).then(
                this.props.handleDataset(this.state.name)
            )
        }else{
            this.setState({
                redirectToHome:true,
            })
        }
     }
    async changeAlgorithm() {
        if(this.state.j48){

            return this.props.changeAlgorithmDataset("J48",this.state.name);

            }else{
                if(this.state.randomTree){
                    return this.props.changeAlgorithmDataset("RandomTree",this.state.name);
                }else{
                    if(this.state.repTree){
                        return this.props.changeAlgorithmDataset("REPTree",this.state.name);
                    }else{
                        if(this.state.furia){
                            return this.props.changeAlgorithmDataset("FURIA",this.state.name);
                        }else{
                            if(this.state.htFuzzy){
                                return this.props.changeAlgorithmDataset("FuzzyHoeffdingDecisionTree",this.state.name);
                            }else{
                                if(this.state.randomForest){
                                    return this.props.changeAlgorithmDataset("RandomForest",this.state.name);
                                }else{

                                }
                            }
                        }
                    }
                }
        }
        /*if (algorithm === "FURIA") {
            var response = await getRules(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        } else {
            response = await getTree(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            console.log(response.error);
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        }*/
    }
    async buildClassifier(){
        const promise = this.changeAlgorithm();
        promise.then(this.buildClassifierPromise)
    }
    async buildClassifierPromise(){
            if (!this.state.j48 &&
                !this.state.randomTree &&
                !this.state.repTree &&
                !this.state.furia &&
                !this.state.htFuzzy &&
                !this.state.randomForest) {
                //Comprobamos que al menos uno este marcado
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageLeatsAlgorithm
                );
            } else {
                if (this.state.file || this.props.classifierExists) {
                    this.setState({
                        loading: true
                    });
                    console.log(this.state.nameError)
                    if (
                        !this.state.nameError &&
                        this.state.file
                    ) {
                        console.log('File')
                        var response = await uploadDataset(
                            this.props.classifierExists ?this.props.dataset:this.state.name,
                            this.state.file,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState(
                                {
                                    dataset: response.data
                                },
                                async () => {
                                        response = await buildSomeClassifier(
                                            this.props.classifierExists ? this.props.dataset:this.state.name,
                                            this.state.j48,
                                            this.state.randomTree,
                                            this.state.repTree,
                                            this.state.furia,
                                            this.state.htFuzzy,
                                            this.state.randomForest,
                                            this.state.J48params,
                                            this.state.Randomparams,
                                            this.state.REPparams,
                                            this.state.FURIAparams,
                                            this.state.HTparams,
                                            this.state.RandomForestParams,
                                            this.props.token
                                    )
                                        if (response.error) {
                                            if (response.status === 401) {
                                                this.props.handleGlobalMessage(
                                                    "error",
                                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                );
                                                this.props.closeSession();
                                                this.setState({
                                                    loading: false,
                                                    redirect: true
                                                });
                                            } else {
                                                //await deleteDataset(this.state.name, this.props.token);
                                                this.setState({
                                                    loading: false,
                                                    error: true,
                                                    message: response.data
                                                },
                                                    );
                                            }
                                        } else {
                                            this.setState({
                                                    classifier:response.data,
                                                },
                                                async () => {
                                                response = await buildSomeModels(
                                                    this.props.classifierExists ?this.props.dataset:this.state.name,
                                                    this.state.j48,
                                                    this.state.randomTree,
                                                    this.state.repTree,
                                                    this.state.furia,
                                                    this.state.htFuzzy,
                                                    this.state.randomForest,
                                                    this.state.J48params,
                                                    this.state.Randomparams,
                                                    this.state.REPparams,
                                                    this.state.FURIAparams,
                                                    this.state.HTparams,
                                                    this.state.RandomForestParams,
                                                    this.props.token,
                                                );
                                                if (response.error) {
                                                    if (response.status === 401) {
                                                        this.props.handleGlobalMessage(
                                                            "error",
                                                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                        );
                                                        this.props.closeSession();
                                                        this.setState({
                                                            loading: false,
                                                            redirect: true
                                                        });
                                                    } else {
                                                        //await deleteDataset(this.state.name, this.props.token);
                                                        this.setState({
                                                            loading: false,
                                                            error: true,
                                                            message: response.data
                                                        });
                                                    }
                                                }  else {
                                                    this.setState(
                                                        {
                                                            classifier: response.data
                                                        },
                                                        async () => {
                                                            response = await buildSomeIEE(
                                                                this.props.classifierExists ?this.props.dataset:this.state.name,
                                                                this.state.j48,
                                                                this.state.randomTree,
                                                                this.state.repTree,
                                                                this.state.furia,
                                                                this.state.htFuzzy,
                                                                this.state.randomForest,
                                                                this.state.J48params,
                                                                this.state.Randomparams,
                                                                this.state.REPparams,
                                                                this.state.FURIAparams,
                                                                this.state.HTparams,
                                                                this.state.RandomForestParams,
                                                                this.props.token
                                                            );
                                                            if (response.error) {
                                                                if (response.status === 401) {
                                                                    this.props.handleGlobalMessage(
                                                                        "error",
                                                                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                                    );
                                                                    this.props.closeSession();
                                                                    this.setState({
                                                                        loading: false,
                                                                        redirect: true
                                                                    });
                                                                } else {
                                                                    this.setState({
                                                                        loading: false,
                                                                        error: true,
                                                                        message: response.data
                                                                    });
                                                                }
                                                            } else {
                                                                this.props.handleGlobalMessage(
                                                                    "success",
                                                                    "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                                                )
                                                                this.setState({
                                                                    loading: false,
                                                                    ready: true
                                                                },
                                                        async () => {
                                                                    response = await buildSomeFingrams(
                                                                        this.props.classifierExists ?this.props.dataset:this.state.name,
                                                                        this.state.j48,
                                                                        this.state.randomTree,
                                                                        this.state.repTree,
                                                                        this.state.furia,
                                                                        this.state.htFuzzy,
                                                                        this.state.randomForest,
                                                                        this.state.J48params,
                                                                        this.state.Randomparams,
                                                                        this.state.REPparams,
                                                                        this.state.FURIAparams,
                                                                        this.state.HTparams,
                                                                        this.state.RandomForestParams,
                                                                        this.props.token
                                                                    );
                                                                    if (response.error) {
                                                                        if (response.status === 401) {
                                                                            this.props.handleGlobalMessage(
                                                                                "error",
                                                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                                            );
                                                                            this.props.closeSession();
                                                                            this.setState({
                                                                                loading: false,
                                                                                redirect: true
                                                                            });
                                                                        } else {
                                                                            this.setState({
                                                                                loading: false,
                                                                                error: true,
                                                                                message: response.data
                                                                            });
                                                                        }
                                                                    } else {
                                                                            this.props.handleGlobalMessage(
                                                                                "success",
                                                                                "Dataset " + this.state.name +this.props.language.labels[this.props.language.id].succesfullyCreated
                                                                            )
                                                                            this.setState({
                                                                                loading: false,
                                                                                ready: true
                                                                            })
                                                                    }
                                                                }
                                                                )
                                                            }
                                                        }

                                                    );
                                                }
                                            });

                                        }
                                }
                            );
                        }
                    } else if (this.props.classifierExists && !this.state.nameError ) {
                        console.log('segundo')
                            response = await buildSomeClassifier(
                                this.props.classifierExists ?this.props.dataset:this.state.name,
                                this.state.j48,
                                this.state.randomTree,
                                this.state.repTree,
                                this.state.furia,
                                this.state.htFuzzy,
                                this.state.randomForest,
                                this.state.J48params,
                                this.state.Randomparams,
                                this.state.REPparams,
                                this.state.FURIAparams,
                                this.state.HTparams,
                                this.state.RandomForestParams,
                                this.props.token
                            )
                            if (response.error) {
                                if (response.status === 401) {
                                    this.props.handleGlobalMessage(
                                        "error",
                                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                    );
                                    this.props.closeSession();
                                    this.setState({
                                        loading: false,
                                        redirect: true
                                    });
                                } else {
                                    //await deleteDataset(this.state.name, this.props.token);
                                    this.setState({
                                            loading: false,
                                            error: true,
                                            message: response.data
                                        },
                                    );
                                }
                            } else {
                                this.setState({
                                        classifier:response.data,
                                    },
                                    async () => {
                                        response = await buildSomeModels(
                                            this.props.classifierExists ?this.props.dataset:this.state.name,
                                            this.state.j48,
                                            this.state.randomTree,
                                            this.state.repTree,
                                            this.state.furia,
                                            this.state.htFuzzy,
                                            this.state.randomForest,
                                            this.state.J48params,
                                            this.state.Randomparams,
                                            this.state.REPparams,
                                            this.state.FURIAparams,
                                            this.state.HTparams,
                                            this.state.RandomForestParams,
                                            this.props.token,
                                        );
                                        if (response.error) {
                                            if (response.status === 401) {
                                                this.props.handleGlobalMessage(
                                                    "error",
                                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                );
                                                this.props.closeSession();
                                                this.setState({
                                                    loading: false,
                                                    redirect: true
                                                });
                                            } else {
                                                //await deleteDataset(this.state.name, this.props.token);
                                                this.setState({
                                                    loading: false,
                                                    error: true,
                                                    message: response.data
                                                });
                                            }
                                        }  else {
                                            this.setState(
                                                {
                                                    classifier: response.data
                                                },
                                                async () => {
                                                    response = await buildSomeFingrams(
                                                        this.props.classifierExists ?this.props.dataset:this.state.name,
                                                        this.state.j48,
                                                        this.state.randomTree,
                                                        this.state.repTree,
                                                        this.state.furia,
                                                        this.state.htFuzzy,
                                                        this.state.randomForest,
                                                        this.state.J48params,
                                                        this.state.Randomparams,
                                                        this.state.REPparams,
                                                        this.state.FURIAparams,
                                                        this.state.HTparams,
                                                        this.state.RandomForestParams,
                                                        this.props.token
                                                    );
                                                    if (response.error) {
                                                        if (response.status === 401) {
                                                            this.props.handleGlobalMessage(
                                                                "error",
                                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                            );
                                                            this.props.closeSession();
                                                            this.setState({
                                                                loading: false,
                                                                redirect: true
                                                            });
                                                        } else {
                                                            this.setState({
                                                                loading: false,
                                                                error: true,
                                                                message: response.data
                                                            });
                                                        }
                                                    } else {
                                                            this.props.handleGlobalMessage(
                                                                "success",
                                                                "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                                            )
                                                            this.setState({
                                                                loading: false,
                                                                ready: true
                                                            }
                                                        );
                                                    }
                                                }

                                            );
                                        }
                                    });

                            }


                    }else{
                        console.log('Pillado')
                        this.setState({
                            error: true,
                            message: "You have an error in the name",
                            loading:false,
                        });
                    }
                } else if (!this.state.file) {
                    this.setState({
                        error: true,
                        message: "Please upload the dataset file"
                    });
                } else {
                    this.setState({
                        error: true,
                        message: "Wrong params, please check fields"
                    });
                }
            }
    }
    selectOneAlgorithm(algoritmo){
        if(algoritmo === "J48"){
            this.setState({
                j48:true,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "RandomTree"){
            this.setState({
                j48:false,
                randomTree:true,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "REPTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:true,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FURIA"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:true,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:true,
                randomForest:false,
            })
        }else if(algoritmo === "RandomForest"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:true,
            })
        }
    }
    handleChangeSwitchA= event => {
        if(this.state.checkedA === false && this.state.checkedB === true){
            this.setState({
                checkedA: true,
                checkedB: false,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else if(this.state.checkedA === false){
            this.setState({
                checkedA: true,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleChangeSwitchB= event => {
        if(this.state.checkedB === false && this.state.checkedA === true){
            this.setState({
                checkedB: true,
                checkedA: false,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(this.state.checkedB === false){
            this.setState({
                checkedB: true,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleAlgorithmClick(algoritmo,checked){
        console.log(algoritmo+" "+checked);
        if(algoritmo === "J48" ){
            if(checked && this.state.randomTree && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,j48:checked});
            }else{
                this.setState({checkedA:false,j48:checked});
            }
            if(!checked && !this.state.randomTree && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,j48:checked});
            }else{
                this.setState({checkedB:false,j48:checked});
            }
        }else if(algoritmo === "RandomTree"){
            if(this.state.j48 && checked && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,randomTree:checked});
            }else{
                this.setState({checkedA:false,randomTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,randomTree:checked});
            }else{
                this.setState({checkedB:false,randomTree:checked});
            }
        }else if(algoritmo === "REPTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,repTree:checked});
            }else{
                this.setState({checkedA:false,repTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,repTree:checked});
            }else{
                this.setState({checkedB:false,repTree:checked});
            }
        }else if(algoritmo === "FURIA"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.repTree && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,furia:checked});
            }else{
                this.setState({checkedA:false,furia:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.repTree && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,furia:checked});
            }else{
                this.setState({checkedB:false,furia:checked});
            }
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.randomForest){
                this.setState({checkedA:true,htFuzzy:checked});
            }else{
                this.setState({checkedA:false,htFuzzy:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.randomForest){
                this.setState({checkedB:true,htFuzzy:checked});
            }else{
                this.setState({checkedB:false,htFuzzy:checked});
            }
        }else if(algoritmo === "RandomForest"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.htFuzzy){
                this.setState({checkedA:true,randomForest:checked});
            }else{
                this.setState({checkedA:false,randomForest:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.htFuzzy){
                this.setState({checkedB:true,randomForest:checked});
            }else{
                this.setState({checkedB:false,randomForest:checked});
            }
        }

    }
    handleChangeName = event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        console.log(event.target)
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            name: event.target.value
        });
    };

    render() {
        const { classes } = this.props;
        /*var comprobationRedirectErrorJ48 = false;
        var comprobationRedirectErrorRep = false;
        var comprobationRedirectErrorRandom = false;
        var comprobationRedirectErrorFuria = false;
        var comprobationRedirectErrorHTFuzzy = false;
        var comprobationRedirectErrorRandomForest = false;
        if(this.state.htFuzzy){
            if(this.state.redirectHtFuzzy) {
                comprobationRedirectErrorHTFuzzy=true;
                this.props.changeAlgorithm("FuzzyHoeffdingDecisionTree")
            }else{
                comprobationRedirectErrorHTFuzzy=false;
            }
        }
        if(this.state.furia){
            if(this.state.redirectFuria) {
                comprobationRedirectErrorFuria=true;
                this.props.changeAlgorithm("FURIA")
            }else{
                comprobationRedirectErrorFuria=false;
            }
        }
        if(this.state.repTree){
            if(this.state.redirectRepTree) {
                comprobationRedirectErrorRep=true;
                this.props.changeAlgorithm("RepTree")
            }else{
                comprobationRedirectErrorRep=false;
            }
        }
        if(this.state.randomTree){
            if(this.state.redirectRandomTree) {
                comprobationRedirectErrorRandom=true;
                this.props.changeAlgorithm("RandomTree")
            }else{
                comprobationRedirectErrorRandom=false;
            }
        }
        if(this.state.j48){
            if(this.state.redirectJ48) {
                comprobationRedirectErrorJ48=true;
                this.props.changeAlgorithm("J48")
            }else{
                comprobationRedirectErrorJ48=false;
            }
        }
        if(this.state.randomForest){
            if(this.state.redirectRandomForest) {
                comprobationRedirectErrorJ48=true;
                this.props.changeAlgorithm("J48")
            }else{
                comprobationRedirectErrorJ48=false;
            }
        }
        console.log(comprobationRedirectErrorFuria)
        console.log(comprobationRedirectErrorHTFuzzy)
        console.log(comprobationRedirectErrorJ48)
        console.log(comprobationRedirectErrorRandom)
        console.log(comprobationRedirectErrorRandomForest)
        console.log(comprobationRedirectErrorRep)*/
        return this.state.loading ? (
            <Fragment>
            <NavBar
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
            />
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
            </Fragment>
        ) : (
            <Fragment>
                <NavBar
                    language={this.props.language}
                    handleLanguageChange={this.props.handleLanguageChange}
                />
                {this.state.j48Configuration === false &&
                    this.state.repTreeConfiguration === false &&
                    this.state.randomTreeConfiguration === false &&
                    this.state.furiaConfiguration === false &&
                    this.state.htFuzzyConfiguration === false &&
                    this.state.randomForestConfiguration === false &&

                <Grid container style={{marginBottom:110}} justify="center">
                    <Grid xs={12} className={classes.container}>
                        {!this.props.classifierExists && (
                        <Fragment>
                            <Typography variant="h4">
                                {this.props.language.labels[this.props.language.id].buildAll}
                            </Typography>
                            <Tooltip title="Dataset file in arff format" placement="top">
                                <Button
                                    className={classes.file}
                                    component="label"
                                    color="primary"
                                    onClick={this.handleButtonClick}
                                >
                                    {this.props.language.labels[this.props.language.id].upload}
                                    {!this.state.file ? (
                                        <CloudUpload className={classes.icon}/>
                                    ) : (
                                        <CheckCircle className={classes.icon}/>
                                    )}
                                    <input
                                        onChange={this.changeFile}
                                        style={{display: "none"}}
                                        type="file"
                                    />
                                </Button>
                            </Tooltip>

                            <Tooltip title="Name to identify dataset" placement="top">
                                <TextField
                                    id="standard-name"
                                    label={
                                        this.props.language.labels[this.props.language.id].datasetName
                                    }
                                    className={classes.textFieldName}
                                    value={this.state.name}
                                    disabled={this.props.classifierExists}
                                    onChange={this.handleChangeName}
                                    margin="normal"
                                    error={this.state.nameError}
                                />
                            </Tooltip>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedA}
                                            disableRipple={true}
                                            classes={{disabled:classes.switchClassDisabled}}
                                            checked={this.state.checkedA}
                                            color="primary"
                                            onChange={this.handleChangeSwitchA}
                                            name="checkedA"
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />}
                                    label={this.props.language.labels[this.props.language.id].selectAll}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedB}
                                            checked={this.state.checkedB}
                                            onChange={this.handleChangeSwitchB}
                                            color="primary"
                                            name="checkedB"
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].deselectAll}
                                />
                            </FormGroup>
                        </Fragment>
                        )}
                        {this.props.classifierExists &&
                        <Fragment>
                            <Typography variant="h4">
                                {this.props.language.labels[this.props.language.id].buildAll2}
                            </Typography>
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        disabled={this.state.checkedA}
                                        disableRipple={true}
                                        classes={{disabled:classes.switchClassDisabled}}
                                        checked={this.state.checkedA}
                                        color="primary"
                                        onChange={this.handleChangeSwitchA}
                                        name="checkedA"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />}
                                label={this.props.language.labels[this.props.language.id].selectAll}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        disabled={this.state.checkedB}
                                        checked={this.state.checkedB}
                                        onChange={this.handleChangeSwitchB}
                                        color="primary"
                                        name="checkedB"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label={this.props.language.labels[this.props.language.id].deselectAll}
                            />
                        </FormGroup>
                        </Fragment>
                        }
                    </Grid>
                    <Grid item xs={12} className={classes.root}>

                        <Fragment>
                            {this.state.algorithms.map(algorithm => {
                                var checked = false;
                                if(algorithm === "J48" && this.state.j48 ){
                                    checked= true;
                                }else if(algorithm === "RandomTree" && this.state.randomTree ){
                                    checked= true;
                                }else if(algorithm === "REPTree" && this.state.repTree ){
                                    checked= true;
                                }else if(algorithm === "FURIA" && this.state.furia ){
                                    checked= true;
                                }else if(algorithm === "FuzzyHoeffdingDecisionTree" && this.state.htFuzzy  ){
                                    checked= true;
                                }else if(algorithm === "RandomForest" && this.state.randomForest ){
                                    checked= true;
                                }
                                return (
                                    <AlgorithmCard
                                        key={algorithm}
                                        language={this.props.language}
                                        handleAlgorithmClick={this.handleAlgorithmClick}
                                        algorithm={algorithm}
                                        configuration={this.configuration}
                                        algorithmChecked={this.props.algorithmChecked}
                                        selectOneAlgorithm = {this.selectOneAlgorithm}
                                        checked = {checked}
                                        showConfig={true}
                                    />
                                );
                            })}
                        </Fragment>

                    </Grid>

                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={this.buildClassifier}
                    >
                        {this.props.language.labels[this.props.language.id].buildButton}
                    </Button>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <Button
                        variant="contained"
                        className={classes.buttonCancel}
                        onClick={this.cancelBuild}
                    >
                        {this.props.language.labels[this.props.language.id].cancelButton}
                    </Button>


                </Grid>
                }
                {this.state.j48Configuration &&
                <FormConfigureJ48
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationJ48 = {this.saveConfigurationJ48}
                    exitConfigurationJ48 = {this.cancelConfigurationJ48}
                />
                }
                {this.state.randomTreeConfiguration  &&
                <FormConfigureRandom
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationRandomTree = {this.saveConfigurationRandomTree}
                    exitConfigurationRandomTree = {this.cancelConfigurationRandomTree}
                />
                }
                {this.state.repTreeConfiguration &&
                <FormConfigurationREP
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationRepTree = {this.saveConfigurationRepTree}
                    exitConfigurationRepTree = {this.cancelConfigurationRepTree}
                />
                }
                {this.state.furiaConfiguration &&
                <FormConfigureFURIA
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationFuria = {this.saveConfigurationFuria}
                    exitConfigurationFuria = {this.cancelConfigurationFuria}
                />
                }
                {this.state.htFuzzyConfiguration &&
                <FormConfigurationHTFuzzy
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationHTFuzzy = {this.saveConfigurationHTFuzzy}
                    exitConfigurationHtFuzzy = {this.cancelConfigurationHTFuzzy}
                />
                }
                {this.state.randomForestConfiguration &&
                <FormConfigureRandomForest
                    language={this.props.language}
                    token={this.props.token}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                    saveConfigurationRandomForest = {this.saveConfigurationRandomForest}
                    exitConfigurationRandomForest = {this.cancelConfigurationRandomForest}
                />
                }
                <footer className={classes.footer}>
                    <Grid container direction="row" alignItems="center" justify={"center"}>
                        <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                            <img
                                src={galicia}
                                alt="logo turístico galicia"
                                className={classes.leftLogos}
                            />
                            <img
                                src={xacobeo}
                                alt="logo xacobeo 2021"
                                className={classes.leftLogos}
                            />
                            <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                            <img src={usc} alt="logo usc" className={classes.leftLogos} />
                            <img
                                src={campusVida}
                                alt="logo campus vida"
                                className={classes.leftLogos}
                            />
                        </Grid>
                        <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                            <img
                                src={ue}
                                alt="logo unión europea"
                                className={classes.rightLogos}
                            />
                            <img
                                src={xunta}
                                alt="logo xunta de galicia"
                                className={classes.rightLogos}
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
                        {this.props.language.labels[this.props.language.id].fondoEuropeo}
                    </Typography>
                </footer>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {!this.props.token ? <Redirect to="/" /> : ""}
                {this.state.redirectToHome && <Redirect to="/" /> }
                {this.state.ready && this.props.handleDataset(this.state.name)}
            </Fragment>

        );
    }
}
Algorithms.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Algorithms);
